import { render, staticRenderFns } from "./sustainabilityCard.vue?vue&type=template&id=303528e6&scoped=true&"
import script from "./sustainabilityCard.vue?vue&type=script&lang=js&"
export * from "./sustainabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./sustainabilityCard.vue?vue&type=style&index=0&id=303528e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303528e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303528e6')) {
      api.createRecord('303528e6', component.options)
    } else {
      api.reload('303528e6', component.options)
    }
    module.hot.accept("./sustainabilityCard.vue?vue&type=template&id=303528e6&scoped=true&", function () {
      api.rerender('303528e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/sustainabilityCard.vue"
export default component.exports